export function helpers() {
  /* Copyright year */
  const d = new Date();
  const copyRightYr = d.getFullYear();
  document.getElementById('copyright-year').innerHTML = copyRightYr;
}